import { VStack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import { investmentContinueUrl } from "@/helpers/investment";
import { useCanReinvest, useUserInvestments } from "@/hooks/useInvestments";
import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";
import { useDocumentTitle } from "@equidefi/portals/hooks/useDocumentTitle";
import { useSavedProfiles } from "@equidefi/portals/hooks/useSavedProfiles";
import InvestmentCard from "../../../components/investment/InvestmentCard";
import { WorkflowContainer } from "../WorkflowContainer";

const WorkflowChooseInvestment = () => {
  const navigate = useNavigate();
  const { offering } = useWorkflowContext();
  const { data: investments, isFetchedAfterMount } = useUserInvestments(
    {
      offering_id: offering?.id,
    },
    { refetchOnMount: "always" },
  );
  const { data: savedProfiles, isFetchedAfterMount: savedProfilesFetched } = useSavedProfiles();
  const canReinvest = useCanReinvest(investments);

  useDocumentTitle("Choose an Investment");

  useEffect(() => {
    if (!isFetchedAfterMount || !savedProfilesFetched) return;
    if (investments?.length > 0) return;

    if (savedProfiles?.length > 0) {
      navigate(`/offerings/${offering.slug}/reinvest`, { replace: true });
      return;
    }

    navigate(`/offerings/${offering.slug}/registration`, { replace: true });
  }, [isFetchedAfterMount, investments, savedProfiles, savedProfilesFetched, offering.slug, navigate]);

  return (
    <WorkflowContainer
      title="Choose An Investment"
      buttonProps={{
        isDisabled: !canReinvest || offering.status !== "ACTIVE",
      }}
      onContinue={() => navigate(`/offerings/${offering.slug}/reinvest`)}
      buttonLabel="Invest Again">
      <VStack gap={4} mb={4} mt={4}>
        {investments?.map((investment) => (
          <InvestmentCard
            key={investment.id}
            investment={investment}
            cardAction={() => {
              const url = investmentContinueUrl(investment.id, investment.next, offering.slug, investment.status);

              navigate(url ?? `/vault/investment/${investment.id}`);
            }}
          />
        ))}
      </VStack>
    </WorkflowContainer>
  );
};

export default WorkflowChooseInvestment;
